/* eslint-disable import/export */
import React from 'react';
import baseLoadable from '@loadable/component';
import FallbackLoader from 'system/components/FallbackLoader';

export const LoadableFallback = () => <FallbackLoader />;

export * from '@loadable/component';

const customLoadable = (func, options = {}) => (
  baseLoadable(func, { ssr: false, fallback: <LoadableFallback />, ...options })
);

export { customLoadable as loadable };

export const loadableLib = (func, options ={}) => (
  baseLoadable.lib(func, { ssr: false, fallback: <LoadableFallback />, ...options })
);
/* eslint-enable import/export */
